import { toast } from 'sonner';
import { deleteTransaction } from './api';

// The backend flags (never deletes) a new transaction that looks like one
// already recorded — same amount, same day, similar merchant (see
// find_possible_duplicate in server.py). Right after saving, give the user a
// one-tap undo; otherwise it stays marked "¿Duplicado?" in Movimientos.
// Returns true when a warning was shown, so callers can skip their own
// success toast.
export function warnIfPossibleDuplicate(txn, onChange) {
  if (!txn?.possible_duplicate_of) return false;
  toast.warning('Parece que ya tenías este movimiento anotado hoy', {
    description: 'Lo guardamos igual. Si está repetido, deshacelo.',
    duration: 8000,
    action: {
      label: 'Deshacer',
      onClick: async () => {
        try {
          await deleteTransaction(txn.id);
          toast.success('Listo, lo quitamos');
          onChange?.();
        } catch {
          toast.error('No se pudo deshacer');
        }
      },
    },
  });
  return true;
}
